import { Box, Button, Divider, MenuItem, Popover } from '@mui/material'

import { memo, useCallback, useEffect, useState } from 'react'
import CustomDateTimePicker from '../../components/date-time-picker'
import CustomTextField from '../../components/textfield'

const defaultFilters = {
  isGlobal: null,
  isOneTimeUse: null,
  fromDate: null,
  toDate: null,
  couponStatus: null,
  tenantId: null
}

const FilterModal = ({
  open,
  anchorEl,
  inputData,
  handleClose,
  handleApplyClick
}) => {
  const [data, setData] = useState(defaultFilters)

  const handleChange = useCallback((key, value) => {
    setData((prev) => ({ ...prev, [key]: value }))
  }, [])

  const handleClearFilter = useCallback(() => {
    handleApplyClick(defaultFilters)
    handleClose()
  }, [handleApplyClick, handleClose])

  useEffect(() => {
    if (open) {
      setData({ ...defaultFilters, ...(inputData || {}) })
    }
  }, [open, inputData])

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Box sx={{ padding: 4, width: 300 }}>
        <Box mb={2}>
          <CustomTextField
            select
            fullWidth
            label="Accessibility"
            value={
              data?.isGlobal === null || data?.isGlobal === undefined
                ? ''
                : String(data?.isGlobal)
            }
            onChange={(e) => {
              const val = e.target.value
              if (val === '') handleChange('isGlobal', null)
              else handleChange('isGlobal', val === 'true')
            }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="true">Global</MenuItem>
            <MenuItem value="false">Tenant Only</MenuItem>
          </CustomTextField>
        </Box>

        <Box mb={2}>
          <CustomTextField
            select
            fullWidth
            label="Usage Type"
            value={
              data?.isOneTimeUse === null || data?.isOneTimeUse === undefined
                ? ''
                : String(data?.isOneTimeUse)
            }
            onChange={(e) => {
              const val = e.target.value
              if (val === '') handleChange('isOneTimeUse', null)
              else handleChange('isOneTimeUse', val === 'true')
            }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="true">ONE TIME</MenuItem>
            <MenuItem value="false">No LIMIT</MenuItem>
          </CustomTextField>
        </Box>

        <Box mb={3}>
          <CustomTextField
            select
            fullWidth
            label="Status"
            value={data?.couponStatus || ''}
            onChange={(e) =>
              handleChange('couponStatus', e.target.value || null)
            }
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="ACTIVE">Active</MenuItem>
            <MenuItem value="INACTIVE">Inactive</MenuItem>
            <MenuItem value="EXPIRED">Expired</MenuItem>
          </CustomTextField>
        </Box>

        <Box mb={3}>
          <CustomDateTimePicker
            name="fromDate"
            label="From Date"
            value={data?.fromDate || null}
            onChange={(value) => handleChange('fromDate', value)}
            showTimeSelect={true}
            allowPreviousDate={true}
            isClearable
            withPortal
            usedInHookForm={false}
          />
        </Box>

        <Box mb={3}>
          <CustomDateTimePicker
            name="toDate"
            label="To Date"
            value={data?.toDate || null}
            onChange={(value) => handleChange('toDate', value)}
            showTimeSelect={true}
            allowPreviousDate={true}
            isClearable
            withPortal
            usedInHookForm={false}
          />
        </Box>
        <Divider sx={{ my: 4 }} />
        <Box display="flex" justifyContent="space-between">
          <Button variant="outlined" size="small" onClick={handleClearFilter}>
            Clear
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              handleApplyClick(data)
            }}
          >
            Apply
          </Button>
        </Box>
      </Box>
    </Popover>
  )
}

export default memo(FilterModal)
